module.exports = "images/okoo.2a18a9fb.png";